import { render } from "./CreateGoalModal.vue?vue&type=template&id=df0b46b8&scoped=true"
import script from "./CreateGoalModal.vue?vue&type=script&lang=js"
export * from "./CreateGoalModal.vue?vue&type=script&lang=js"

import "./CreateGoalModal.vue?vue&type=style&index=0&id=df0b46b8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0b46b8"]])

export default __exports__